<div class="with-floating-button">
    <div class="content">
        <page-header #pageHeader
                     [title]="'admin.frais.fournisseurs.infos.generalites' | translate"
                     [listeItems]="listeTabItems"
                     (onGoBack)="goBack()"
                     (onSelectedItemChange)="onTabChange($event)"
                     [isPending]="isSaving">
        </page-header>
        <router-outlet></router-outlet>
    </div>
    <floating-button *ngIf="listeActions?.value?.length" [listeActions]="listeActions" [isPending]="isSaving"></floating-button>
</div>
